import { useTranslation } from "react-i18next";
import { formatPrice } from "../../../../../../Utils/ServiceUtils/ServiceUtils";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import React from "react";
import { Tooltip, Avatar } from "@mui/material";
import moment from "moment";

const ServiceDeviceDetails = ({ device }) => {
  const { t } = useTranslation();
  if (!device?.uuid) return null;

  const footer =
    moment(moment(device?.deviceWarrantyTo).format("YYYY-MM-DD")).isSameOrAfter(
      moment().format("YYYY-MM-DD"),
    ) ||
    moment(moment(device?.partsWarrantyTo).format("YYYY-MM-DD")).isSameOrAfter(
      moment().format("YYYY-MM-DD"),
    ) ? (
      <Tooltip
        style={{ cursor: "pointer" }}
        title={`${t("global:device.deviceWarranty")}`}
      >
        <Avatar className="DeviceAvatar DeviceAvatarViolet">G</Avatar>
      </Tooltip>
    ) : (
      <span></span>
    );

  return (
    <div>
      {" "}
      <BMXSeparator
        title={t("global:service.basicDeviceInfo")}
        footer={footer}
      />
      <div className="device-details">
        <div className="grid-line" />
        <div className="label">{t("global:service.manufacturerAndModel")}</div>
        <div className="value">
          {device?.printerModel?.manufacturer?.entryName}{" "}
          {device?.printerModel?.modelName}
        </div>

        <div className="label">{t("global:service.deviceType")}</div>
        <div className="value">
          {device?.printerModel?.deviceType.entryName}
        </div>

        <div className="label">{t("global:service.deviceOwner")}</div>
        <div className="value">{device?.deviceOwner?.entryName || "-"}</div>

        <div className="label highlight">
          {t("global:service.servicePriority")}
        </div>
        <div className="value">{device?.servicePriority?.entryName || "-"}</div>

        <div className="label">{t("global:service.servicePrice")}</div>
        <div className="value">
          {device?.printerModel?.servicePrice?.name || "-"}
        </div>

        {[
          ["Przegląd okresowy", "surveyPrice"],
          ["Naprawa", "repairPrice"],
          ["Instalacja", "installationPrice"],
          ["Diagnostyka", "diagnosticsPrice"],
          ["Usługa IT", "itServicePrice"],
          ["Usługa zdalna", "remotePrice"],
        ].map(([label, key], index) => (
          <React.Fragment key={key}>
            <div className={`label ${index === 0 ? "section-start" : ""}`}>
              {label}
            </div>
            <div
              className={`value price ${index === 0 ? "section-start" : ""}`}
            >
              {formatPrice(device?.printerModel?.servicePrice?.[key])} PLN
            </div>
          </React.Fragment>
        ))}

        <div className="label section-start">{t("global:service.client")}</div>
        <div className="value section-start">{device?.client?.name}</div>
        <div className="label">{t("global:service.fullLocal")}</div>
        <div className="value">
          {`${device?.branch?.address || ""}, ${
            device?.branch?.postCode || ""
          } ${device?.branch?.city || ""}`}
        </div>
      </div>
    </div>
  );
};

export default ServiceDeviceDetails;
